// extracted by mini-css-extract-plugin
export default {"overlay":"overlay_overlay__En2gA","overlay_active":"overlay_overlay_active__aqnTA"};